/**
 * LeMaBelle Favori Ürünler Yöneticisi
 * Hibrit: localStorage (guest) + Backend API (login)
 */
(function () {
    'use strict';

    const API_BASE = 'https://shopify.verimek.com/api/favorites';
    const STORAGE_KEY = 'lemabelle_favorites';
    const COUNTER_SELECTOR = '[data-favorites-count]';

    // Shopify Liquid'den gelen customer bilgisi (theme.liquid'de set edilecek)
    const customerId = window.__lemabelle_customer_id || null;

    // ─── LocalStorage Helpers ───────────────────────────
    function getLocal() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        } catch { return []; }
    }

    function setLocal(items) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }

    function isInLocal(productId) {
        return getLocal().some(f => f.productId === Number(productId));
    }

    function addToLocal(product) {
        const items = getLocal().filter(f => f.productId !== Number(product.productId));
        items.unshift({
            productId: Number(product.productId),
            productHandle: product.productHandle || '',
            productTitle: product.productTitle || '',
            productImage: product.productImage || '',
            productPrice: Number(product.productPrice) || 0,
            variantId: product.variantId || null,
            addedAt: new Date().toISOString()
        });
        setLocal(items);
    }

    function removeFromLocal(productId) {
        const items = getLocal().filter(f => f.productId !== Number(productId));
        setLocal(items);
    }

    // ─── API Helpers ────────────────────────────────────
    async function apiAdd(product) {
        if (!customerId) return;
        try {
            await fetch(API_BASE + '/add', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId, ...product })
            });
        } catch (e) { console.warn('Favori API add hatası:', e); }
    }

    async function apiRemove(productId) {
        if (!customerId) return;
        try {
            await fetch(API_BASE + '/remove', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId, productId: Number(productId) })
            });
        } catch (e) { console.warn('Favori API remove hatası:', e); }
    }

    async function apiList() {
        if (!customerId) return [];
        try {
            const res = await fetch(API_BASE + '/list?customerId=' + customerId);
            const data = await res.json();
            return data.success ? data.data : [];
        } catch (e) { console.warn('Favori API list hatası:', e); return []; }
    }

    async function apiSync() {
        if (!customerId) return;
        const localFavs = getLocal();
        if (localFavs.length === 0) return;

        try {
            const res = await fetch(API_BASE + '/sync', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId, favorites: localFavs })
            });
            const data = await res.json();
            if (data.success) {
                // Backend'deki listeyi localStorage'a yaz (birleşik liste)
                const merged = data.data.map(f => ({
                    productId: f.productId,
                    productHandle: f.productHandle,
                    productTitle: f.productTitle,
                    productImage: f.productImage,
                    productPrice: f.productPrice,
                    variantId: f.variantId,
                    addedAt: f.createdAt
                }));
                setLocal(merged);
                console.log('✅ Favoriler senkron edildi:', data.synced, 'yeni');
            }
        } catch (e) { console.warn('Favori sync hatası:', e); }
    }

    // ─── Public API ─────────────────────────────────────
    window.LemabelleFavorites = {
        /**
         * Favori durumunu kontrol et
         */
        isFavorite(productId) {
            return isInLocal(Number(productId));
        },

        /**
         * Favori ekle/çıkar (toggle)
         */
        async toggle(productId, productData) {
            const pid = Number(productId);

            if (isInLocal(pid)) {
                removeFromLocal(pid);
                apiRemove(pid);
                updateAllButtons(pid, false);
                updateCounter();
                return false;
            } else {
                const data = { productId: pid, ...productData };
                addToLocal(data);
                apiAdd(data);
                updateAllButtons(pid, true);
                updateCounter();
                return true;
            }
        },

        /**
         * Favori listesini getir
         */
        getAll() {
            return getLocal();
        },

        /**
         * Toplam favori sayısı
         */
        getCount() {
            return getLocal().length;
        },

        /**
         * Favorilerden çıkar (sadece remove)
         */
        async remove(productId) {
            const pid = Number(productId);
            removeFromLocal(pid);
            apiRemove(pid);
            updateAllButtons(pid, false);
            updateCounter();
        }
    };

    // ─── UI Güncellemeleri ──────────────────────────────
    function updateAllButtons(productId, isFav) {
        document.querySelectorAll(`[data-fav-btn][data-product-id="${productId}"]`).forEach(btn => {
            const heartFilled = btn.querySelector('.fav-heart-filled');
            const heartEmpty = btn.querySelector('.fav-heart-empty');
            if (heartFilled && heartEmpty) {
                heartFilled.style.display = isFav ? 'block' : 'none';
                heartEmpty.style.display = isFav ? 'none' : 'block';
            }
            btn.classList.toggle('is-favorited', isFav);
        });
    }

    function updateCounter() {
        const count = getLocal().length;
        document.querySelectorAll(COUNTER_SELECTOR).forEach(el => {
            el.textContent = count || '';
            el.style.display = count > 0 ? '' : 'none';
        });
    }

    // ─── Init ───────────────────────────────────────────
    function init() {
        // Sayfa yüklenince tüm butonları güncelle
        document.querySelectorAll('[data-fav-btn]').forEach(btn => {
            const pid = Number(btn.dataset.productId);
            if (isInLocal(pid)) {
                updateAllButtons(pid, true);
            }
        });

        // Sayaçları güncelle
        updateCounter();

        // Giriş yapılmışsa senkron et
        if (customerId) {
            apiSync().then(() => {
                // Senkron sonrası butonları tekrar güncelle
                document.querySelectorAll('[data-fav-btn]').forEach(btn => {
                    const pid = Number(btn.dataset.productId);
                    updateAllButtons(pid, isInLocal(pid));
                });
                updateCounter();
            });
        }
    }

    // DOM hazır olunca başlat
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
